import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getPartnerProgramUrl } from 'pricing-pages-lib/utils/publicPageUrls';
import safeLocalStorage from 'pricing-pages-lib/utils/safeLocalStorage';
import { isPartnerProgramEligibleSelector } from 'pricing-pages-ui/selectors/PartnerProgramSelectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'self... Remove this comment to see the full error message
import { isPaidHub } from 'self-service-api/core/utilities/parcelUtils';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';
const PartnerProgramBanner = () => {
  const isBannerDismissed = safeLocalStorage.getItem(BANNER_DISMISSED_KEY);
  const isPartnerProgramEligible = useSelector(isPartnerProgramEligibleSelector);
  const [shouldShowBanner, setShouldShowBanner] = useState(!isBannerDismissed && isPartnerProgramEligible);
  const closeBanner = () => {
    setShouldShowBanner(false);
    safeLocalStorage.setItem(BANNER_DISMISSED_KEY, true);
  };
  const partnerProgramLink = getPartnerProgramUrl();
  const handleClick = () => {
    trackClickedLink({
      name: 'partner-banner-more-info',
      value: 'Click here',
      type: 'external',
      url: partnerProgramLink
    });
  };
  useEffect(() => {
    let isMounted = true;
    isPaidHub().then(hasPaidProduct => {
      if (isMounted) {
        setShouldShowBanner(isPartnerProgramEligible && !hasPaidProduct && !isBannerDismissed);
      }
    }).catch(error => {
      console.error(error);
      setShouldShowBanner(false);
    });
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!shouldShowBanner) return null;
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium-id": "partner-program-banner",
    type: "info",
    closeable: true,
    onClose: closeBanner,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.promotions.partnerProgram.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "pricingPage.promotions.partnerProgram.text_jsx",
      elements: {
        UILink: Link
      },
      options: {
        link: partnerProgramLink,
        onClick: handleClick
      }
    })
  });
};
export default PartnerProgramBanner;